import LoginPage from '../Pages/LoginPage';

const LoginRoutes = () => {

  return (
    <LoginPage />
  );
}
export default LoginRoutes;
